// removed by extract-text-webpack-plugin
module.exports = {"container":"players__container___2bNRn","startGameBtn":"players__startGameBtn___3Z7QA","noplayers":"players__noplayers___2XGWj","demoBtn":"players__demoBtn___2PvES","dartboardSVG":"players__dartboardSVG___2aMsf"};


//////////////////
// WEBPACK FOOTER
// ./containers/Players/players.css
// module id = 278
// module chunks = 0